import { render, staticRenderFns } from "./allSurgeresInvoices.vue?vue&type=template&id=20a2e3a9"
import script from "./allSurgeresInvoices.vue?vue&type=script&lang=js"
export * from "./allSurgeresInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports